import { render, staticRenderFns } from "./LastSessions.vue?vue&type=template&id=f35a579c"
import script from "./LastSessions.vue?vue&type=script&lang=js"
export * from "./LastSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports